import { CustomLoadingIcon } from '../../../supplementary_components/loading_icon';
import { InputFieldDelegate } from '../../forms/input_fields/inputFieldDelegate';
import { RemoveButton } from './buttons';
import styles from './inputWithOptions.module.scss';
// import { InputFieldDelegate } from '../general_components/forms/input_fields/inputFieldDelegate';
// import { RemoveButton } from '../general_components/content_management/reusableItems/buttons';

export const InputWithOptions = ({selectedItemNames, setSelectedItems, noLabel, preDefindedOptions, itemLabel, allSelected, columnConfig, dataIsLoading}) => {
    return <div className={styles.selector}>
        {!noLabel ? <div className={styles.label}>{`Selected ${itemLabel}(s):`}</div> : null}
        <div className={`${styles.container} ${!allSelected||styles.allItems}`}>
            {selectedItemNames.map((itemName, index) =>{
                return <div key={index} className={`${styles.selectedItem}  non-selectable`}>{itemName}<RemoveButton customColor={"var(--light-gray)"} action={()=>{setSelectedItems(prev => prev.filter(name => name !== itemName));}} /></div>
            })}
            { allSelected ?
            null:
            columnConfig ?
            <InputFieldDelegate index={0} column={columnConfig} noStyling={true} />
            :
            null
        }
        </div>
        {dataIsLoading ? <CustomLoadingIcon height={'1.4rem'} speed={1} customStrokeWidth="0.3rem" customClassName={styles.loadingIconContainer} /> : <div className={styles.loadingIconReplacer} ></div>}
    </div>
}